// extracted by mini-css-extract-plugin
export default {"search-user-title":"SearchUser_search-user-title__byzOo","search-container":"SearchUser_search-container__qm3cX","search-accounts-title":"SearchUser_search-accounts-title__EVGXp"};